import { useTheme } from "@mui/material";
import { Link2 } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { PinKind } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	kind: PinKind;
	isLast: boolean;
	onClick: () => void;
};

export const PinExistingOptionRow: FC<Props> = ({ kind, isLast, onClick }) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();
	const kindResources = Resources.PortfolioDetail.Pin.Kind[kind];

	return (
		<ListRow
			showChevron
			onClick={onClick}
			icon={<Link2 size={iconSize.md} color={palette.blue[600]} />}
			iconBg={palette.blue[50]}
			title={t(kindResources.existingTitle)}
			subtitle={t(kindResources.existingSubtitle)}
			isLast={isLast}
		/>
	);
};
